import CirconstanceCard from "@/components/shared/circonstance-card";
import type { DeclarationStepProps } from '@/pages/accident/declaration-sinistre/types';

interface Circonstance {
    number: number;
    text: string;
}

const circonstances: Circonstance[] = [
    {
        number: 1,
        text: 'en stationnement / à l\'arrêt'
    },
    {
        number: 2,
        text: 'quittait un stationnement / ouvrait une portière'
    },
    {
        number: 3,
        text: 'prenait un stationnement'
    },
    {
        number: 4,
        text: 'sortait d\'un parking, d\'un lieu privé, d\'un chemin de terre',
    },
    {
        number: 5,
        text: 's\'engageait dans un parking, un lieu privé, un chemin de terre',
    },
    {
        number: 6,
        text: 's\'engageait sur une place à sens giratoire',
    },
    {
        number: 7,
        text: 'roulait sur une place à sens giratoire',
    },
    {
        number: 8,
        text: 'heurtait à l\'arrière en roulant dans le même sens et sur même file',
    },
    {
        number: 9,
        text: 'roulait dans le meme sens et sur une file différente',
    },
    {
        number: 10,
        text: 'changeait de file',
    },
    {
        number: 11,
        text: 'doublait',
    },
    {
        number: 12,
        text: 'virait à droite',
    },
    {
        number: 13,
        text: 'virait à gauche',
    },
    {
        number: 14,
        text: 'reculait',
    },
    {
        number: 15,
        text: 'empiétait sur une voie reservée à la circulation et en sens inverse',
    },
    {
        number: 16,
        text: 'venait de droite (dans un carrefour)',
    },
    {
        number: 17,
        text: 'n\'avait pas observé un signal de priorité ou un feu rouge',
    },
]

const Circonstances = (props: DeclarationStepProps) => {
    const {values, setValue} = props

    let totalA = 0
    let totalB = 0

    const formCirc = values.circonstances || {}
    Object.entries(formCirc).forEach(([n, o]) => {
        if (n.startsWith('coche_a') && o === true){
            totalA++
        }
        if (n.startsWith('coche_b') && o === true){
            totalB++
        }
    });

    /* Pas de calcul de responsabilité / cas IDA sur l'espace client : la déclaration est faite par
       le client, c'est au gestionnaire de déterminer la responsabilité. On ne remplit donc plus
       manuel_resp/manuel_ida via le barème cas_ida (l'ABS) et on n'appelle plus cet endpoint. */

    return (
        <div className={'bloc-white'}>
            <div className="md:flex-[0_0_100%] md:max-w-[100%] min-[576px]:flex-[0_0_100%] min-[576px]:max-w-[100%]">
                <h4 className={'font-bold text-[oklch(from_var(--color-primary)_calc(l*0.95)_c_h)] inline-block mb-2'}>Circonstances</h4>
                <p className={'mb-12'}>Attention de bien mettre les cases bien identiques à celles cochées sur le constat amiable.</p>

                <span className={'align-left inline-block w-1/2 font-bold h5'}>Vous<br/>{values.conduct}</span>
                <span className={'align-right inline-block w-1/2 font-bold h5'}>L'adversaire<br/>{values.adversaires[0].nom} {values.adversaires[0].prenom}</span>
            </div>

            <div className="md:flex-[0_0_100%] md:max-w-[100%] min-[576px]:flex-[0_0_100%] min-[576px]:max-w-[100%] mb-4">
                {
                    circonstances.map((c, i) =>
                        <CirconstanceCard key={i}>
                            <label className={'float-left relative'}>
                                <input
                                    type="checkbox"
                                    name={`circonstancesvalues`}
                                    value={`coche_a${c.number}`}
                                    onChange={() => setValue(`circonstances`, {...values.circonstances, ['coche_a'+c.number]: !values.circonstances[`coche_a${c.number}`] }) }
                                />
                            </label>
                            <p>
                                <b className={'h5 font-bold'} style={{float: 'left'}}>{c.number}</b>
                                <span>{c.text}</span>
                                <b className={'h5 font-bold'} style={{float: 'right'}}>{c.number}</b>
                            </p>
                            <label className={'float-right relative'}>
                                <input
                                    type="checkbox"
                                    name={`circonstancesvalues`}
                                    value={`coche_b${c.number}`}
                                    onChange={() => setValue(`circonstances`, {...values.circonstances, ['coche_b'+c.number]: !values.circonstances[`coche_b${c.number}`] }) }
                                />
                            </label>
                        </CirconstanceCard>
                    )
                }
                <p className={'text-center font-weight-bold mt-6'} style={{fontSize: 20}}>
                    <span className={'float-left ml-4'}>{totalA}</span>
                    Total
                    <span className={'float-right mr-4'}>{totalB}</span>
                </p>
            </div>
        </div>
    );
};

export default Circonstances;
